import * as authService from "../api/auth"
import {auth} from "../api/auth"

interface UserSession {
  userId: number;
  userName: string;
  sessionId: string;
  expirationTimestamp: string;
  firstName: string;
  lastName: string;
  micadUser: boolean;
  roles: Role[];
}

interface Role {
  id: number;
  name: string;
}

export async function getUserSession(): Promise<UserSession|null> {
  if (process.env.NODE_ENV === "test") {
    return null
  }
  try {
    const r = await authService.api.get("/api/user/session",
      {params: {userId: auth.userId, sessionId: auth.sessionId}})
    if (!r) {
      return null
    }
    return r.data as UserSession
  } catch (err) {
    console.error("getUserSession", err)
    return null
  }
}
